import React from 'react'
import { Link } from 'react-router-dom'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import Moment from 'react-moment'
import Swal from 'sweetalert2'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
import Button from '../../common/CustomComponents/Button'
class AddtionalHourList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    cat: this.props.match.params.boatType,
  }
  componentDidMount() {
    this.dashbord()
  }
  dashbord = async () => {
    var that = this
    this.setState({ isloading: true })
    var cruiseId = this.props.match.params.boatId
    await axios
      .get(Constant.getAPI() + `/cruise/list-cruise-additional-hour/${cruiseId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ isloading: false })
          that.setState({
            Products_data: res.data.data,
          })
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteProducts = (id) => {
    //var cruiseId = this.props.match.params.boatId
    var data = {
      additional_hour_id: id,
    }
    axios
      .delete(Constant.getAPI() + `/cruise/delete-cruise-additional-hour`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        data,
      })
      .then(() => {
        Swal.fire({
          title: 'Additional hours Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.dashbord()
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    const columns = [
      {
        name: 'additional_hour',
        label: `Addtional Hour`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (additional_hour) => {
            return <div>{additional_hour} Hr</div>
          },
        },
      },
      {
        name: 'updatedAt',
        label: 'Date',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (updatedAt) => {
            return (
              <div>
                <Moment format="DD/MM/YYYY">{updatedAt}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'updatedAt',
        label: 'Time(hrs:min:sec)',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (updatedAt) => {
            return (
              <div>
                <Moment format="HH:mm:ss">{updatedAt}</Moment>
              </div>
            )
          },
        },
      },
      {
        name: 'destination_address_en',
        label: `Destination Address: English`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'destination_address_ar',
        label: `Destination Address: English`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'price',
        label: `Sunday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'monday_price',
        label: `Monday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'tuesday_price',
        label: `Tuesday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'wednesday_price',
        label: `Wednesday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'thursday_price',
        label: `Thursday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'friday_price',
        label: `Friday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'saturday_price',
        label: `Saturday Price`,
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <div>{value >= 0 ? value : '--'}</div>,
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-end align-items-center">
                <Link
                  to={
                    `/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/additionalhours-add/` +
                    id
                  }
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteProducts.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]
    const options = {
      filterType: true,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      search: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Additional Hour List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title d-flex justify-content-end align-items-center">
                      <li className="mr-2">
                        <Button
                          to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/additionalhours-add`}
                          startIcon={<i className="icofont icofont-plus m-r-5"></i>}
                          className="f-right text-white"
                        >
                          Add
                        </Button>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link
                          to={`/viewboat-details/${this.props.match.params.boatType}/${this.props.match.params.boatId}`}
                        >
                          {this.props.match.params.boatType} Details{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Additional Hour List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="card">
                <div className="dt-responsive table-responsive">
                  {this.state?.isloading ? (
                    <div className="p-20">loading...</div>
                  ) : (
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.Products_data}
                      columns={columns}
                      options={options}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AddtionalHourList
